// Libraries
import styled from 'styled-components'

type MenuContainerProps = {
  active: boolean
}

export const Wrapper = styled.header`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white03};
  box-shadow: 0px 0.5px 3px rgba(125, 125, 125, 0.1);
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 21px 0px;
  border-radius: 0px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    padding: 16px 0px 16px 0px; 
  }
`

export const MenuContainer = styled.div<MenuContainerProps>`
  background-color: ${({ theme }) => theme.colors.white02};
  position: absolute;
  top: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 3;
  clip-path: polygon(
    ${({ active }) =>
      active ? '0 0, 100% 0, 100% 100%, 0 100%' : '0 0, 100% 0, 100% 0, 0 0'}
  );
  transition: all 0.2s ease-in-out;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    display: none;
  }
`

export const NavBar = styled.div`
  margin-top: 14px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    margin-top: 0px;
  }
`
